<template>
  <TutorialView
    :cards="cards"
    game="cards"
  />
</template>

<script>
import TutorialView from '@/components/games/tutorial/TutorialView.vue';

export default {
  name: 'CardsTutorial',
  components: {
    TutorialView,
  },
  data: () => ({
    cards: [
      {
        text: 'GAME.CARDS.TUTORIAL.CARDS_WITH_NEWS',
      },
      {
        // image: 'rosco',
        text: 'GAME.CARDS.TUTORIAL.SWIPE_OR_BUTTONS',
      },
    ],
  }),
  // created() {
  //   // Add pre-form
  //   this.cards.push({
  //     text: 'GAME.CARDS.TUTORIAL.BEFORE_STARTING',
  //     form: this.$store.getters['evaluate/byScreen']('cards'),
  //   });
  // },
};
</script>
